import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'

const TopicClosed = () => (
  <div className='box box--info box--rounded'>
    <div className='box__pad qa-mesg-topic-closed'><Phrase p='topic.closed.info_message' /></div>
  </div>
)

export default TopicClosed
